module.exports = {
    title: 'contractsView-contractsView_checkingAccountCustomizeCardTitle',
    order: 5,
    footer_text: '',
    position: 'middle',
    components: [
        {
            id_component: 'card-image-selector',
            id: 'card-image-selector',
            cardImageIds: [
                'B.506.002.020',
            ],
            cardImageIdsFF: [
                "B.506.002.020", 
            ],
            cardImageIdsFutureMode: [
                'B.506.002.020',
            ],
            onChange: 'checkingPayrollAccount_handleCardImageChange',
        },
        {
            id_component: 'card-pin-change',
            id: 'card-pin-change',
            onBlur: 'checkingPayrollAccount_handlePinBlur',
        },
    ]
};